module.exports = __webpack_public_path__ + "img/car-27.9da4fa8d.jpg";